// extracted by mini-css-extract-plugin
export default {"App":"SuccessLinked_App__gJdMR","container":"SuccessLinked_container__9nkxp"};